import PERMISSIONS from '@/constants/permissions';
import { BRANCH_SERVICE_THUMBNAIL, BRANCH_THUMBNAIL } from '@/constants/path';
import { ServiceModel } from '@/typings/models/Location';

/** Endpoint, path params and edit permission for a branch's or a branch service's thumbnail. */
export function thumbnailTarget(branchId: string, serviceId?: string) {
  return serviceId
    ? { path: BRANCH_SERVICE_THUMBNAIL, params: { serviceId }, permission: PERMISSIONS.BranchServices.EDIT }
    : { path: BRANCH_THUMBNAIL, params: { branchId }, permission: PERMISSIONS.Branches.EDIT };
}

/** A service's own image (deletable) vs the one it inherits from its service type. */
export function splitServiceThumbnail(service?: Pick<ServiceModel, 'thumbnail' | 'thumbnail_source'>) {
  const url = service?.thumbnail || null;
  return {
    own: service?.thumbnail_source === 'service_type' ? null : url,
    inherited: service?.thumbnail_source === 'service_type' ? url : null,
  };
}
